import { kebabCase } from 'lodash-es';

import type { Undefinable } from '@zen/utils/typescript';

import type { BookingListColumn } from './types';
import { BookingScope } from './types';

const TABLE_ID_PREFIX: string = 'bookings-list';

const DRAFTS_EMPTY_TEXT: string = 'There are no drafts to show.';

export const getTableId = (scope: BookingScope): string => `${TABLE_ID_PREFIX}-${kebabCase(scope)}`;

const scopeTableTitles: Record<BookingScope, string> = {
  [BookingScope.APPROVED]: 'Approved bookings',
  [BookingScope.CONFIRMED]: 'Confirmed bookings',
  [BookingScope.DRAFTS]: 'Draft bookings',
  [BookingScope.REJECTED]: 'Rejected bookings',
  [BookingScope.REQUESTED]: 'Requested bookings'
};

export const getTableTitle = (scope: BookingScope): string => scopeTableTitles[scope];

export const getEmptyText = (scope: BookingScope): Undefinable<string> => {
  if (scope === BookingScope.DRAFTS) {
    return DRAFTS_EMPTY_TEXT;
  }

  return undefined;
};

const referenceColumn: BookingListColumn = { key: 'reference', sortable: false, title: 'Reference' };

const baseColumns: BookingListColumn[] = [
  { key: 'modeOfTransport', sortable: false, title: 'Mode' },
  { key: 'cargo', sortable: false, title: 'Cargo' },
  { key: 'milestone', sortable: false, title: 'Milestone' },
  { key: 'origin', sortable: false, title: 'Origin' },
  { key: 'destination', sortable: false, title: 'Destination' },
  { key: 'incoterm', sortable: false, title: 'Incoterm' },
  { key: 'cargoReadyDate', sortable: false, title: 'CRD' },
  { key: 'requiredDeliveryDate', sortable: false, title: 'RDD' }
];

const draftColumns: BookingListColumn[] = [
  { key: 'expiresOn', sortable: false, title: 'Expires on' },
  { key: 'createdBy', sortable: false, title: 'Created by' }
];

const draftActionsColumn: BookingListColumn = { fixed: 'right', key: 'actions', sortable: false, title: '', width: 100 };

const bookingColumns: BookingListColumn[] = [referenceColumn, ...baseColumns];

const scopeColumns: Record<BookingScope, BookingListColumn[]> = {
  [BookingScope.APPROVED]: bookingColumns,
  [BookingScope.CONFIRMED]: bookingColumns,
  [BookingScope.DRAFTS]: [referenceColumn, ...baseColumns, ...draftColumns, draftActionsColumn],
  [BookingScope.REJECTED]: bookingColumns,
  [BookingScope.REQUESTED]: bookingColumns
};

export const getBookingListColumns = (scope: BookingScope): BookingListColumn[] => scopeColumns[scope];
